// utils/appConfig.js
import { getTranslations } from './appLanguage';
import { applySiteBranding, SITE_CONFIG } from '../config/siteConfig';

export const getAppBaseConfig = (platform, authData = {}) => {
  const { isAndroidApp, deviceId, deviceLanguage, deviceArch, deviceMemory } = authData;
  
  return {
    ...SITE_CONFIG,
    isTelegramWebApp: platform === 'telegram',
    isBrowser: platform === 'browser',
    isMobile: /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    isAndroidApp: isAndroidApp || false,
    deviceId: deviceId || null,
    language: deviceLanguage || navigator.language.slice(0, 2),
	deviceArch: deviceArch || null, 
    deviceMemory: deviceMemory || null,
    isDarkMode: window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false,
    appVersion: '1.0.0',
  };
};

export const mergeAppConfig = (baseConfig, baseLang, targetLang, level, userInfo, serverGameLevel) => {
  const isAdvanced = ['B1', 'B2', 'C1', 'C2'].includes(level);
  const selectedLang = isAdvanced ? targetLang : baseLang;

  return {
    ...baseConfig,
    language: selectedLang, // не используется
    baseLanguage: baseLang,
    targetLanguage: targetLang,
    level,
    serverGameLevel,
	userInfo,
	t: applySiteBranding(getTranslations(selectedLang)),
  };
};
